import React, { useContext, useEffect, useState } from "react";
// import MediaQuery from 'react-responsive';
import { useTranslation } from "react-i18next";
import { sify } from "chinese-conv";
import {
  AssetItem,
  AssetItemName,
  AssetItemPrice,
} from "../../../../AssetListScreenStyles";
import Row from "react-bootstrap/Row";
import { CarouselWrapper } from "../../../../../../Widget/Carousel";
import { reducer } from "../../../../../../../../context";
import actionType from "../../../../../../../../context/actionType";
import Button from "react-bootstrap/Button";
import { Asset } from "../../../../../../../../interface/Server";
// import {MarkerProps} from "react-google-maps/lib/components/Marker";
// import {CustomAssetGroup, CustomAssetChild} from "../../../../../../../../interface/Client";

interface Props {
  asset: Asset;
  onSelectAsset?: (asset: Asset) => void;
  hideButton?: boolean;
  nameplateDisplay?: boolean;
  displayImage?: boolean;
  isMobile?: boolean;
  isGroupItem?: boolean;
}

export const getDisplayName = (
  language: string,
  englishName: string,
  chineseName: string
) => {
  console.info("getDisplayName");
  console.info(language);
  console.info(englishName);
  console.info(chineseName);
  switch (language) {
    case "zhTW":
      return !!chineseName ? chineseName : englishName;
    case "cn":
      return !!chineseName ? sify(chineseName) : englishName;
    default:
      return englishName;
  }
};

// Component that contains parent and dropdown children assets
const AssetListItem: React.FunctionComponent<Props> = (props) => {
  const {
    assetId,
    englishName,
    chineseName,
    technicalName,
    giftAmount,
    giftAmountCurrency,
    inventoryId,
    venueEn,
    venueZh,
    zone,
    image,
    images,
    description,
  } = props.asset;
  const displayInventoryId = props.nameplateDisplay ? inventoryId : "";
  const { googleMapReducer } = useContext(reducer);
  const { t, i18n } = useTranslation();
  const displayName = getDisplayName(i18n.language, englishName, chineseName);
  const useChi = i18n.language === "zhTW" || i18n.language === "cn";
  const handleClickAsset = () => {
    console.log("clicked asset", props.asset);
    googleMapReducer.dispatch({
      type: actionType.googleMap.GOOGLE_EDIT_SELECTED_MARKER,
      payload: {
        selectedMarker: props.asset,
      },
    });
  };
  return props.isMobile ? (
    <AssetItem key={assetId} isMobile={props.isMobile} isRow={props.isMobile}>
      {props.isGroupItem && (
        <div
          style={{
            width: "147px",
            height: "147px",
          }}
        />
      )}
      {!props.isGroupItem && props.displayImage && (
        <div style={{ marginRight: 13 }}>
          <CarouselWrapper images={images} isMobile={props.isMobile} />
        </div>
      )}
      <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
        <div
          style={
            !props.nameplateDisplay
              ? {
                  flex: 1,
                  display: "flex",
                  flexDirection: "row",
                  marginRight: 12,
                  marginLeft: 12,
                  marginTop: 10.5,
                }
              : { flex: 1 }
          }
        >
          <div style={{ flex: 1 }}>
            <AssetItemName
              isChinese={useChi}
              style={{ fontSize: 14 }}
            >{`${displayName} ${displayInventoryId}`}</AssetItemName>
            <AssetItemName isChinese={useChi} style={{ fontSize: 14 }}>{`${
              zone ? `${zone} - ` : ""
            }${venueEn || venueZh || ""}`}</AssetItemName>
            {props.nameplateDisplay && (
              <AssetItemName isChinese={useChi} truncate>{`${
                description || ""
              }`}</AssetItemName>
            )}
          </div>
          <AssetItemName
            isChinese={useChi}
            style={
              !props.nameplateDisplay
                ? { fontSize: 14, textAlign: "right" }
                : {}
            }
          >
            {`${giftAmountCurrency}${giftAmount.toLocaleString()}`}
          </AssetItemName>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginRight: 12,
            marginBottom: 12,
            marginTop: 12,
            ...(props.isMobile &&
              !props.nameplateDisplay && { justifyContent: "flex-end" }),
          }}
        >
          {props.nameplateDisplay && (
            <AssetItemName isChinese={useChi}>
              {`${t("scientificName")}: ${technicalName}`}
            </AssetItemName>
          )}
          {!props.hideButton && (
            <Button
              onClick={() =>
                props.onSelectAsset && props.onSelectAsset(props.asset)
              }
              variant={"primary"}
              style={{
                backgroundColor: "#2c3e50",
                borderColor: "#2c3e50",
                ...(useChi
                  ? { fontFamily: "Microsoft JhengHei" }
                  : { fontFamily: "Rambla" }),
              }}
            >
              {t("select")}
            </Button>
          )}
        </div>
      </div>
    </AssetItem>
  ) : (
    <AssetItem key={assetId}>
      <Row
        onClick={() => handleClickAsset()}
        style={{ padding: 0, display: "flex", height: "147px", margin: 0 }}
      >
        {props.isGroupItem && (
          <div
            style={{
              width: "220px",
              height: "147px",
            }}
          />
        )}
        {!props.isGroupItem && props.displayImage && (
          <div
            style={{
              width: "220px",
              height: "147px",
            }}
          >
            <CarouselWrapper images={images} />
          </div>
        )}
        <div
          style={{
            flex: 2,
            display: "flex",
            flexDirection: "column",
            ...(!props.nameplateDisplay
              ? { padding: "20px" }
              : { paddingLeft: "20px" }),
          }}
        >
          {!props.nameplateDisplay ? (
            <div style={{ flex: 1 }}>
              <AssetItemName
                isChinese={useChi}
              >{`${displayName} ${displayInventoryId}`}</AssetItemName>
              <AssetItemName isChinese={useChi} location>{`${
                zone ? `${zone} - ` : ""
              }${(useChi ? venueZh : venueEn) || ""}`}</AssetItemName>
            </div>
          ) : (
            <>
              <div style={{ flex: 1 }}>
                <AssetItemPrice
                  isChinese={useChi}
                >{`${displayName} ${displayInventoryId}`}</AssetItemPrice>
                <AssetItemPrice isChinese={useChi} location>{`${
                  zone ? `${zone} - ` : ""
                }${(useChi ? venueZh : venueEn) || ""}`}</AssetItemPrice>
                <AssetItemName isChinese={useChi} truncate>{`${
                  description || ""
                }`}</AssetItemName>
              </div>
              <AssetItemName isChinese={useChi}>
                {`${t("scientificName")}: ${technicalName}`}
              </AssetItemName>
            </>
          )}
        </div>
        <div
          style={{
            minWidth: "150px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            borderLeftStyle: "solid",
            borderColor: "#d4d8d8",
            borderLeftWidth: "1px",
            padding: "0px 8px",
            margin: "8px 0px",
          }}
        >
          <AssetItemPrice isChinese={useChi}>
            {`${giftAmountCurrency}${giftAmount.toLocaleString()}`}
          </AssetItemPrice>
          {!props.hideButton && (
            <Button
              onClick={() =>
                props.onSelectAsset && props.onSelectAsset(props.asset)
              }
              variant={"primary"}
              style={{
                backgroundColor: "#2c3e50",
                borderColor: "#2c3e50",
                width: "90%",
                ...(useChi
                  ? { fontFamily: "Microsoft JhengHei" }
                  : { fontFamily: "Rambla" }),
              }}
            >
              {t("select")}
            </Button>
          )}
        </div>
      </Row>
    </AssetItem>
  );
};

AssetListItem.defaultProps = {
  onSelectAsset: () => {},
  hideButton: false,
  isGroupItem: false,
};

export default AssetListItem;
